import { render, staticRenderFns } from "./approved.vue?vue&type=template&id=866a81c0&"
import script from "./approved.vue?vue&type=script&lang=js&"
export * from "./approved.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports